
import Vue from "vue";
import Api from "@/services/Api";
import { AxiosResponse } from "axios";
import { Overlay } from "@/lib/Overlay";
import { TableOptions } from "@/models/TableOptions";
import AfiliadosRecebimentos from "@/components/AfiliadosRecebimentos.vue";
import moment from "moment";
import { Snackbar } from "@/lib/Snackbar";
import Swal from "sweetalert2";
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

export interface AfiliadosPessoas {
  cadastro: string;
  nome: string;
  usuario: string;
}

export default Vue.extend({
  name: "Afiliados",

  data() {
    return {
      menuInitialDate: false,
      menuFinalDate: false,
      isMobile: false,
      loadingData: true,
      lang: navigator.language,
      errors: [],
      moment: moment,
      ModuloInfo: [],
      linkConvite: "",
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      options: {} as TableOptions,
      headersAfiliados: [
        { text: "Cadastro", value: "cadastro", sortable: false },
        { text: "Nome", value: "nome", sortable: false },
        { text: "Usuário", value: "usuario", sortable: false },
      ],
      headersRecebimentos: [
        { text: "Data", value: "data", sortable: false },
        { text: "Afiliado", value: "pessoa", sortable: false },
        { text: "Valor", value: "valorFormatado", sortable: false },
      ],

      dessertsAfiliados: new Array<AfiliadosPessoas>(),
      loadingDesserts: false,
      totalDesserts: 0,
      totalDessertsRecebimentos: 0,
      timeout: 0,
    };
  },
  components: {
    AfiliadosRecebimentos,
  },
  created() {
    this.isMobile = this.detectMobile();
    this.moduloInfo();
    //this.loadAfiliados();
  },

  methods: {
    doDelayedSearchAfiliados() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        //this is your existing function
        this.loadAfiliados();
      }, 1000);
    },
    loadAfiliados() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.loadingDesserts = true;
      Overlay.show();
      Api.get("/v2/client/afiliados/afiliados", {
        params: {
          page: page,
        },
      })
        .then((response) => {
          this.dessertsAfiliados = response.data.body
            .rows as AfiliadosPessoas[];
          this.totalDesserts = Number(response.data.body.count);
        })
        .finally(() => {
          Overlay.hide();
          this.loadingDesserts = false;
        });
    },

    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    moduloInfo() {
      const id = this.$route.params.id;
      Overlay.show();

      this.loadingData = true;
      Api.get("/v2/client/afiliados/info")
        .then((response) => {
          this.ModuloInfo = response.data.body.moduloInfo;
          this.linkConvite = response.data.body.compartilhamento.link_pessoal;
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status != 200) {
            //exe
          }
          // this.resetRecaptcha();
        })
        .finally(() => {
          this.loadingData = false;
          Overlay.hide();
        });
    },
    doCopy(str: string) {
      this.$copyText(str).then(function (e) {
        Snackbar.show("Copiado com sucesso!");
      });
    },

    onCopy() {
      // console.log(str);

      Snackbar.show("Copiado com sucesso!");
    },
    onCopyError() {
      // console.log(str);

      Snackbar.show("Erro ao copiar para área de transferência", "error");
    },
  },
  watch: {
    options: {
      handler() {
        this.loadAfiliados();
      },
    },
    search: {
      handler() {
        this.doDelayedSearchAfiliados();
      },
    },
  },
});
